<template>
  <div class="WScaffold" :class="class">
    <!-- mask content when sidebars are open  -->
    <transition name="fade">
      <div class="mask" @click="handleMaskClick" v-if="leftIsOpen || rightIsOpen" />
    </transition>
    <div class="top"><slot name="top" /></div>

    <!-- content with collapsible left and right sidebars -->
    <div class="body">
      <div class="left-panel" :class="{ open: leftIsOpen }"><slot name="left-panel" /></div>
      <div class="center-content"><slot name="content" class="center" /></div>
      <div class="right-panel" :class="{ open: rightIsOpen }"><slot name="right-panel" /></div>
    </div>

    <!-- bottom navigation buttons should fit here -->
    <div class="bottom"><slot name="bottom" /></div>
    <!-- provide a global portal for modals -->
    <slot name="portal" class="portal" />
  </div>
</template>

<script lang="ts">
  export default {
    name: 'WScaffold',
    components: {},
    props: ['leftIsOpen', 'rightIsOpen', 'class'],
    emits: ['update:leftIsOpen', 'update:rightIsOpen'],
    methods: {
      handleMaskClick() {
        this.$emit('update:leftIsOpen', false);
        this.$emit('update:rightIsOpen', false);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables';
  @import '@/assets/styles/mixins';

  .WScaffold {
    height: 100vh; // fallback
    height: 100dvh;

    display: grid;
    grid-template-rows: auto 1fr auto;
    overflow: hidden;
    position: relative;
    z-index: 0;

    .body {
      height: 100%;
      overflow: hidden;
      display: flex;

      .left-panel,
      .right-panel {
        height: 100%;
      }

      .center-content {
        height: 100%;
        width: 100%;
        overflow: hidden;
        flex-grow: 1;
      }
    }
    .mask {
      position: absolute;
      inset: 0;
      background-color: $modal-mask;
      display: none;
    }
  }

  @include mobile {
    .WScaffold {
      .body {
        grid-template-columns: 1fr;
      }

      .left-panel {
        transform: translateX(-500%);
      }
      .right-panel {
        transform: translateX(500%);
      }

      .left-panel,
      .right-panel {
        position: absolute;
        top: 0;
        bottom: 0;
        transition: all ease-in-out 0.6s;
        max-width: 70vw; // mask should always be shown
        z-index: 100;
        overflow: none;

        &.open {
          transform: translateX(0);
        }
      }
      .mask {
        display: block;
        z-index: 90;
      }
      .portal {
        z-index: 200;
      }
    }
  }
</style>
